import { routes as addresses } from './addresses'
import { routes as companies } from './companies'
import { routes as covenants } from './covenants'
import { routes as prices } from './prices'
import { routes as staffs } from './staffs'
import { routes as employees } from './employees'
import { routes as documents } from './documents'

export default [
  ...addresses,
  ...companies,
  ...covenants,
  ...prices,
  ...staffs,
  ...employees,
  ...documents
]



// WEBPACK FOOTER //
// ./src/app/professional/company/routes.js